import { Suspense } from 'react'
import { lazyNamed } from '#/shared/lib/version-check'
import type { NoteEditorProps } from './note-editor'

const LazyNoteEditor = lazyNamed(
  () => import('./note-editor'),
  (m) => m.NoteEditor,
)

function NoteEditorFallback({ minHeight }: { minHeight?: number }) {
  return (
    <div
      className="w-full animate-pulse rounded-md border border-gray-200 bg-gray-50"
      style={{ minHeight: minHeight ?? 150 }}
    />
  )
}

export function NoteEditor(props: NoteEditorProps) {
  return (
    <Suspense fallback={<NoteEditorFallback minHeight={props.minHeight} />}>
      <LazyNoteEditor {...props} />
    </Suspense>
  )
}
